<template lang="pug">
.tabela-selecionar-territorio-monitoramento.view-container
    .tabela-wrapper
        h3 {{ $t('mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.titulo') }}
        .tabela-header
            .flex

            .tabela-rodape--pagination
                el-pagination(
                    small,
                    layout='sizes, prev, pager, next',
                    :page-size.sync='paginacao.tamanho',
                    :current-page.sync='paginacao.pagina + 1',
                    :total='dadosTabelaMonitoramento.totalItens',
                    :page-sizes='[10, 20, 50]',
                    @current-change='mudarPagina',
                    @size-change='mudarTamanhoPagina'
                )
        el-table(
            ref='multiplaSelecao',
            :data='dadosTabelaMonitoramento.itens',
            stripe,
            style='width: 100%',
            @selection-change='handleSelecionarRows'
        )
            el-table-column(type='selection', width='55')
            el-table-column(
                prop='nome',
                :label='$t("mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.territorio")',
                min-width='200px'
            )
                template(slot-scope='scope')
                    span {{ scope.row.nome }}
            el-table-column(
                :formatter='formatAreaHaTableColumn',
                prop='areaHa',
                min-width='150px',
                label='Área (ha)'
            )
            el-table-column(
                :label='$t("mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.localidade")',
                prop='municipio',
                min-width='200px'
            )
                template(slot-scope='scope')
                    p {{ scope.row.localidade }}
            el-table-column(
                :label='$t("mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.idPessoa")',
                prop='idCliente'
            )
                template(slot-scope='scope')
                    .representante(
                        v-if='scope.row.representantes && scope.row.representantes.length > 0'
                    )
                        p {{ scope.row.representantes[0].idCliente }}
                    .representante(v-else)
                        p -
            el-table-column(
                :label='$t("mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.pessoa")',
                prop='representante',
                min-width='200px'
            )
                template(slot-scope='scope')
                    .representante(
                        v-if='scope.row.representantes && scope.row.representantes.length > 0'
                    )
                        p {{ scope.row.representantes[0].nomeRazaoSocial }}
                            span ({{ formatCpfCnpj(scope.row.representantes[0].documento) }})
                            el-popover(
                                placement='bottom',
                                popper-class='el-popper-in-table',
                                trigger='hover'
                            )
                                el-tag.ml-2(
                                    v-if='scope.row.representantes.length > 1',
                                    size='mini',
                                    slot='reference'
                                ) {{ scope.row.representantes.length - 1 }}
                                div(
                                    v-for='(representante, index) in scope.row.representantes',
                                    :key='index'
                                ) {{ representante.nomeRazaoSocial }}
                                    span ({{ formatCpfCnpj(representante.documento) }})
                    .representante(v-else)
                        p -
            el-table-column(prop='codigo', label='CAR', min-width='300px')
                template(slot-scope='scope')
                    .car(v-if='scope.row.cars && scope.row.cars.length > 0')
                        p.car-hiden-row {{ scope.row.cars[0].codigo }}
                            el-popover(
                                placement='bottom',
                                popper-class='el-popper-in-table',
                                trigger='hover'
                            )
                                el-tag.ml-2(
                                    v-if='scope.row.cars.length > 1',
                                    size='mini',
                                    slot='reference'
                                ) {{ scope.row.cars.length - 1 }}
                                div(
                                    v-for='(car, index) in scope.row.cars',
                                    :key='index'
                                ) {{ car.codigo }}
                    .car(v-else)
                        p -
    .tabela-rodape
        .tabela-rodape--esquerda
            p {{ $t('mensagens.monitoramentoAgricola.selecionarTerritorioMonitoramento.tabela.rodape', { quantidade_selecionada: rowsSelecionadas.length, quantidade_total: dadosTabelaMonitoramento.totalItens }) }}
        .tabela-rodape--pagination
            el-pagination(
                small,
                layout='sizes, prev, pager, next',
                :page-size.sync='paginacao.tamanho',
                :current-page.sync='paginacao.pagina + 1',
                :total='dadosTabelaMonitoramento.totalItens',
                :page-sizes='[10, 20, 50]',
                @current-change='mudarPagina',
                @size-change='mudarTamanhoPagina'
            )
    ModalCadastrarMonitoramentoAgricola(
        :territoriosSelecionados='territoriosSelecionados',
        :show.sync='mostrarModalCadastroAgricola',
        @cadastrarMonitoramentoAgricola='cadastrarMonitoramento'
    )
</template>

<script>
import formatters from '@/utils/formatters';
import MonitoramentoSocioambientalService from '@/services/MonitoramentoSocioambientalService';
import MonitoramentoAgricolaService from '@/services/MonitoramentoAgricolaService';
import ModalCadastrarMonitoramentoAgricola from '@/components/monitoramento/ModalCadastrarMonitoramentoAgricola.vue';
import { mapActions } from 'vuex';

import TipoMonitoramento from '@/constants/TipoMonitoramento.js';
export default {
    name: 'TabelaSelecionarTerritorioMonitoramento',
    components: { ModalCadastrarMonitoramentoAgricola },
    props: {
        icone: {
            type: String,
            default: () => ''
        },
        texto: {
            type: String,
            default: () => ''
        },
        numero: {
            type: String,
            default: () => ''
        },

        dadosTabelaMonitoramento: {
            type: Object,
            default: () => {}
        },

        tipo: {
            type: String,
            default: () => ''
        },

        paginacao: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            rowsSelecionadas: [],
            territoriosSelecionados: [],
            mostrarModalCadastroAgricola: false,
            checked: false
        };
    },

    methods: {
        ...mapActions([
            'setprocessandoMonitoramento',
            'addListaProcessamentoMonitoramento'
        ]),

        handleSelecionarRows: function (val) {
            this.rowsSelecionadas = val;
            this.$emit('rows-selecionados-changed', val);
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        },

        formatAreaHaTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa, 2);
        },

        utf8Decode(municipio) {
            return formatters.utf8Decode(municipio);
        },

        mudarPagina(pagina) {
            this.$emit('atualizar-pagina', pagina);
        },

        mudarTamanhoPagina(tamanho) {
            this.paginacao.tamanho = tamanho;
            this.paginacao.pagina = 0;
            this.$emit('atualizar-pagina', this.paginacao);
        },

        visualizarTerritorio: function (row) {
            this.$router.push({ name: 'DadosTerritorio' });
        },

        iniciarMonitoramento() {
            const areasMonitoramento = [];
            this.rowsSelecionadas.forEach(r => {
                areasMonitoramento.push({
                    ...r,
                    idTerritorio: r.id,
                    tipoMonitoramento: this.tipo
                });
            });

            if (this.tipo === TipoMonitoramento.SOCIOAMBIENTAL) {
                this.addListaProcessamentoMonitoramento(areasMonitoramento);
                this.cadastrarMonitoramento(areasMonitoramento);
                this.setprocessandoMonitoramento(true);

                setTimeout(() => {
                    this.setprocessandoMonitoramento(false);
                    this.limparListaProcessamentoMonitoramento();
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.monitoramentoSocioambiental.monitorarProcessamento.sucess'
                        )
                    });
                }, areasMonitoramento.length * 5000);
            } else if (this.tipo === TipoMonitoramento.AGRICOLA) {
                this.mostrarModalCadastroAgricola = true;
                this.territoriosSelecionados = areasMonitoramento;
            }

            this.$emit('iniciar-monitoramento', areasMonitoramento);
        },

        cadastrarMonitoramento(areasMonitoramento) {
            let service = null;

            if (this.tipo === TipoMonitoramento.SOCIOAMBIENTAL) {
                service =
                    MonitoramentoSocioambientalService.enviarAreasMonitoramento(
                        {
                            areasMonitoramento
                        }
                    );
            } else if (this.tipo === TipoMonitoramento.AGRICOLA) {
                service = MonitoramentoAgricolaService.enviarAreasMonitoramento(
                    {
                        areasMonitoramento
                    }
                );
            }

            service
                .then(response => {
                    if (response.status === 200) {
                        if (this.tipo === TipoMonitoramento.AGRICOLA) {
                            this.$notify.success({
                                message: this.$t(
                                    'mensagens.monitoramentoSocioambiental.monitorarProcessamento.sucess'
                                )
                            });
                            this.$router.push({
                                name: 'MonitoramentoAgricola'
                            });
                        }
                        this.$router.push({
                            name: 'MonitoramentoSocioambiental'
                        });
                    } else {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.monitoramentoSocioambiental.monitorarProcessamento.erro'
                            )
                        });
                    }
                })
                .catch(e => {
                    this.$notify.error({
                        message:
                            e?.response?.data?.message ??
                            this.$t(
                                'mensagens.monitoramentoSocioambiental.monitorarProcessamento.erro'
                            )
                    });
                });
            this.rowsSelecionadas = [];
            this.$refs.multiplaSelecao.clearSelection();
            this.mostrarModalCadastroAgricola = false;
        },

        exportarDados: function (row) {}
    }
};
</script>

<style lang="scss">
.tabela-selecionar-territorio-monitoramento {
    h3 {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .tabela-header {
        align-items: flex-start !important;
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 10px;
        margin-top: 8px;
        margin-bottom: 8px;
        border-radius: 6px;
        box-shadow: 0px 3px 5px 0px var(--block-shadow);
    }

    .custom-pagination .el-pagination__pager li:not(.el-pager):before {
        display: none;
    }

    .tabela-header--esquerda {
        p {
            margin-bottom: 0;
            color: var(--primary);

            span {
                font-weight: bold;
                font-size: 1rem;
            }
        }
    }

    .tabela-header--pagination {
        display: flex;
    }

    .el-table {
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        border-radius: 6px;
    }

    .el-table thead {
        color: var(--primary);
        font-weight: 400;
        font-size: 13px;
    }

    .tabela-btn {
        margin-top: 14px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 10px;
        margin-top: 8px;
        border-radius: 6px;
        box-shadow: 0px 3px 5px 0px var(--block-shadow);

        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
        }
    }

    .tabela-rodape--pagination {
        .el-pager li.active {
            color: var(--white);
            font-weight: 900;
            background: var(--primary);
        }

        .el-pager li {
            padding: 0 4px;
            background: var(--white);
            vertical-align: top;
            display: inline-block;
            font-size: 13px !important;
            min-width: 28px !important;
            height: 28px !important;
            line-height: 28px !important;
            box-sizing: border-box;
            text-align: center;
            margin: 0;
            border-radius: 2px;
            color: var(--primary);
        }

        .el-pagination button {
            height: 28px;
        }
    }

    .car-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .car {
        display: flex;
    }
}

.button-green {
    border-color: var(--secondary-two);
    color: var(--white);
    background: var(--secondary-two);
}

.button-green.is-disabled {
    color: var(--white);
    background-color: #80a09e;
    border-color: #80a09e;
}

.el-popper-in-table {
    line-height: 1.6;
    max-height: 400px;
    overflow-y: auto;
}

.el-popover__reference-wrapper {
    cursor: pointer;
}

.flex {
    display: flex;

    p {
        margin-left: 25px;
        font-weight: bold;
    }
}

.total-itens {
    font-weight: bold;
    font-size: 14px;
    margin: 0 5px;
}
</style>
